import React from 'react';
import Article from '../../components/article/Article';
import { sample1, sample2, sample3, sample4, sample5 } from './imports';
import './blog.css';


const Blog = () => (
    <div className="sam__blog section__padding" id="blog">
        <div className="sam__blog-heading" dir='rtl'>
            <h1 className="gradient__text">نمونه کار های ما</h1>
        </div>
        <div className="sam__blog-container">
            <div className="sam__blog-container_groupA">
                <Article imgUrl={sample4} date="وب سایت فروشگاهی" text="طراحی وب سایت فروشگاهی با توجه به موضوع کسب و کار شما و انتخاب مناسب ترین تم و رنگ بندی." />
            </div>
            <div className="sam__blog-container_groupB">
                <Article imgUrl={sample2} date="www.ahanatieh.com" text="طراحی وب سایت شرکت فولاد مهر آتیه ساز" />
                <Article imgUrl={sample3} date="rosa-diamond.com" text="طراحی وب سایت شرکت الماس رزا" />
                <Article imgUrl={sample5} date="وب سایت" text="طراحی اختصاصی با استفاده از گرافیست." />
                <Article imgUrl={sample1} date="وب سایت" text="انتخاب تم رنگی با توجه به سلیقه شما." />
            </div>
        </div>
    </div>
);


export default Blog;
